export default import.meta.ROLLDOWN_FILE_URL_L8Fs_TmwgLeEJ8oqil9r1g